import { FC } from 'react'
import cn from 'classnames'
import { Link } from 'components/Link'
import { FieldFormItem } from 'forms/FieldFormItem'
import FieldMobilePhone from 'forms/FieldMobilePhone'
import { compose, phoneMobileNumberValid, required } from 'forms/validators'
import { Button } from 'shared/components/Button'

import { CONSEST_DATA_PERSONAL_DOC_ACTUAL, PROVISION_OF_FREIGHT_FORWARDING_SERVICES_ACTUAL } from '../../constants'

interface OrderGuestSubmitProps {
  className?: string
}

const OrderGuestSubmit: FC<OrderGuestSubmitProps> = ({ className }) => (
  <div className={cn(className, 'rounded-md bg-primary-container p-4')}>
    <FieldFormItem label="Введите номер вашего телефона" name="username">
      <FieldMobilePhone
        name="username"
        placeholder="+7 000 000-00-00"
        size="lg"
        validate={compose(required, phoneMobileNumberValid)}
      />
    </FieldFormItem>

    <div>
      Продолжая, вы подтверждаете, что ознакомлены и согласны с условиями{' '}
      <Link className="!text-on-surface-link" target="_blank" to={PROVISION_OF_FREIGHT_FORWARDING_SERVICES_ACTUAL}>
        договора-оферты
      </Link>
      , даёте согласие на{' '}
      <Link className="!text-on-surface-link" target="_blank" to={CONSEST_DATA_PERSONAL_DOC_ACTUAL}>
        обработку персональных данных
      </Link>
    </div>

    <Button className="mt-6 w-full" size="lg" type="submit" variant="solid">
      Войти / Зарегистрировать KDV ID
    </Button>

    <div className="mt-6 text-body-sm text-on-surface-variant">
      KDV&nbsp;ID&nbsp;&mdash; это сервис для надежной авторизации для российских сайтов и&nbsp;приложений. Пользователи
      с&nbsp;учётной записью в&nbsp;KDV&nbsp;ID получают быстрый вход без ввода данных и&nbsp;могут сразу&nbsp;же начать
      работать.
    </div>
  </div>
)

export default OrderGuestSubmit
